/*eslint jsx-a11y/anchor-is-valid: "off"*/
import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';

import getSlug from '../service/slug-service';
import './menuitem.css';

const MenuItem = ({
  data,
  image,
  type,
  subtype,
  ribbonTitle,
  title,
  version,
  date,
  subtitle,
  highlightText,
  slug,
  modal_content,
  modal_class,
  modal_size,
  description,
  subChildren,
}) => {
  let item = null;

  const [modalShow, setModalShow] = React.useState(false);

  const subLink = (modal_content, linkText, slug, className) => {
    if (modal_content) {
      return (
        <a className={className} href="#" onClick={() => setModalShow(true)}>
          {linkText}
        </a>
      );
    } else {
      return (
        <Link className={className} to={'/' + slug}>
          {linkText}
        </Link>
      );
    }
  };

  const modal = modal_content ? (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size={modal_size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className={modal_class} dangerouslySetInnerHTML={{ __html: modal_content }} />
      </Modal.Body>
      <Modal.Footer>
        <Button className="item-container-modal-button" onClick={() => setModalShow(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  ) : undefined;

  const readMore = subLink(modal_content, 'Read more', slug, 'item-container-read-more');

  if (type === 'plain') {
    item = (
      <>
        {subLink(modal_content, title, slug, 'item-title')}
        <div className="item-metadata">
          Version {version} {date}
        </div>
      </>
    );
  }

  if (type === 'preview') {
    item = (
      <>
        <div className="item-container-image">
          <img src={image} alt={title} />
        </div>
        <div className="item-container-content">
          <p className="item-subtitle">{subtitle}</p>
          <h2 className="item-title">{title}</h2>
          {readMore}
        </div>
        <div className="item-container-footer">
          <p className="item-metadata">{description[0]}</p>
          <p className="item-metadata">{date}</p>
        </div>
      </>
    );
  }

  if (type === 'big-preview') {
    item = (
      <>
        <Link className="item-container-image" to={"/"+slug}>
          {subtype?.includes('feature') && ribbonTitle && <div className="item-container-image-ribbon" >{ribbonTitle}</div>}
          <img src={image} alt={title} />
        </Link>

        <div className="item-container-content">
          <h1 className="item-title"><Link to={"/"+slug}>{title}</Link></h1>
          {date && date !== '' && <p className="item-metadata">{date}</p>}
          <p className="item-subtitle">{subtitle}</p>
          {subtype?.includes('main-feature')  &&<p className="item-subtitle">{highlightText}</p>}
        </div>
      </>
    );
  }

  if (type === 'historical') {
    item = (
      <>
        <div className="item-container-title">
          <h3 className="item-date">{date}</h3>
          <h3 className="item-title">{title}</h3>
          <div className="item-container-image">{image && <img src={image} alt={title} />}</div>
        </div>

        <div className="item-container-divider">
          <span className="dot" />
        </div>

        <div className="item-container-content">
          <p>{subtitle}</p>
          {readMore}
        </div>
      </>
    );
  }

  if (type === 'article') {
    item = (
      <>
        <h1 className="item-title">{title}</h1>

        <div className="item-container-image">
          <img src={image} alt={title} />
        </div>

        <div className="item-container-content">
          <p className="item-subtitle">{subtitle}</p>

          <p>{readMore}</p>

          {description.map((x) => {
            return <p className="item-container-description">{x}.</p>;
          })}
        </div>
      </>
    );
  }

  if (type === 'accordion') {
    item = (
      <Accordion.Item eventKey={slug}>
        <Accordion.Header>
          <h1>
            <img src={image} alt={title} />
            {title}
          </h1>
        </Accordion.Header>
        <Accordion.Body>
          <div className={modal_class} dangerouslySetInnerHTML={{ __html: modal_content }} />
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  if (type === 'icon') {
    item = (
      <>
        <div className="item-container-image">
          <img src={image} alt={title} />
        </div>

        <h1 className="item-title">{subLink(modal_content, title, slug, 'item-title')}</h1>
      </>
    );
  }

  if (type === 'panel') {
    let first = true;
    item = (
      <>
        <div className="item-container-image">
          <img src={image} alt={title} />
        </div>
        <h1 className="item-title">{title}</h1>

        <div className="item-container-content">
          <p className="item-subtitle">{subtitle}</p>
        </div>

        <div className="item-container-submenu">
          {subChildren.map((child) => {
            let separator = '';
            if (first) {
              first = false;
            } else {
              separator = ' | ';
            }
            const childSlug = getSlug(child.node.title);
            return (
              <span className="item-title" key={childSlug}>
                {separator}
                {subLink(modal_content, child.node.title, childSlug, 'item-title')}
              </span>
            );
          })}
        </div>
        {readMore}
      </>
    );
  }

  let containerClass = `item-container-${type}`;

  if (subtype) {
    containerClass = `${containerClass}-${subtype}`;
  }

  const itemContainer = (
    <div className={containerClass}>
      {item}
      {modal}
    </div>
  );

  return itemContainer;
};

MenuItem.propTypes = {
  type: PropTypes.string,
  version: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.arrayOf(PropTypes.string),
  slug: PropTypes.string,
  modal_content: PropTypes.string,
  modal_class: PropTypes.string,
  modal_size: PropTypes.string,
  subChildren: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
};

MenuItem.defaultProps = {
  type: 'plain',
  modal_size: 'xl',
};

export default MenuItem;
